module.exports = __webpack_public_path__ + "img/gimpel.b6f2e168.jpg";